/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { Type } from '@sinclair/typebox';
import { MerchantScreeningPluginSchema } from './merchant-screening-plugin-schema.js';
import { BusinessInformationPluginSchema } from './schemas/business-information-plugin-schema.js';
import { CompanySanctionsPluginSchema } from './schemas/company-sanctions-plugin-schema.js';
import { MerchantMonitoringPluginSchema } from './schemas/merchant-monitoring-plugin-schema.js';
import { CollectionFlowStatusesEnum } from '../../utils/collection-flow/enums/collection-flow-status-enum.js';
import { CollectionFlowStepStatesEnum } from '../../utils/collection-flow/enums/collection-flow-step-state-enum.js';
import '../../utils/collection-flow/validators/index.js';
import '../../utils/collection-flow/schemas/config-schema.js';
import { AmlSchema } from './schemas/aml-schema.js';
import { DocumentsSchema } from './schemas/documents-schema.js';
import { EntitySchema } from './schemas/entity-schema.js';
import { IndividualSanctionsPluginSchema } from './schemas/individual-sanctions-plugin-schema.js';
import { KycSessionPluginSchema } from './schemas/kyc-session-plugin-schema.js';
import { RiskEvaluationPluginSchema } from './schemas/risk-evaluation-plugin-schema.js';
import { UboPluginSchema } from './schemas/ubo-plugin-schema.js';

var defaultInputContextSchema = Type.Object({
  customData: Type.Optional(Type.Object({}, {
    additionalProperties: true
  })),
  entity: Type.Union([Type.Composite([EntitySchema, Type.Object({
    ballerineEntityId: Type.String()
  })]), Type.Composite([EntitySchema, Type.Object({
    id: Type.String()
  })])]),
  documents: DocumentsSchema
});
var defaultPluginSchema = Type.Object({
  name: Type.String(),
  status: Type.String(),
  orderId: Type.String(),
  invokedAt: Type.Number(),
  data: Type.Optional(Type.Any())
});
var CollectionFlowStepSchema = Type.Object({
  stepName: Type.String(),
  state: Type.Optional(Type.Enum(CollectionFlowStepStatesEnum)),
  reason: Type.Optional(Type.String()),
  // Deprecated and should be removed in the future
  isCompleted: Type.Optional(Type.Boolean())
});
var CollectionFlowConfigSchema = Type.Object({
  apiUrl: Type.String()
});
var CollectionFlowStateSchema = Type.Object({
  currentStep: Type.String(),
  status: Type.Enum(CollectionFlowStatusesEnum),
  steps: Type.Optional(Type.Array(CollectionFlowStepSchema))
});
var CollectionFlowSchema = Type.Object({
  config: Type.Optional(CollectionFlowConfigSchema),
  state: Type.Optional(CollectionFlowStateSchema),
  additionalInformation: Type.Optional(Type.Object({
    customerCompany: Type.Optional(Type.String())
  }))
});
var defaultContextSchema = Type.Composite([defaultInputContextSchema, Type.Object({
  aml: AmlSchema,
  pluginsOutput: Type.Optional(Type.Object({
    ubo: UboPluginSchema,
    kyc_session: KycSessionPluginSchema,
    companySanctions: CompanySanctionsPluginSchema,
    individualSanctions: IndividualSanctionsPluginSchema,
    merchantMonitoring: MerchantMonitoringPluginSchema,
    businessInformation: BusinessInformationPluginSchema,
    merchantScreening: MerchantScreeningPluginSchema,
    riskEvaluation: RiskEvaluationPluginSchema
  }, {
    additionalProperties: true
  }))
}), Type.Object({
  collectionFlow: Type.Optional(CollectionFlowSchema)
})]);

export { CollectionFlowConfigSchema, CollectionFlowSchema, CollectionFlowStateSchema, CollectionFlowStepSchema, defaultContextSchema, defaultInputContextSchema, defaultPluginSchema };
//# sourceMappingURL=default-context-schema.js.map
